import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  slots: [],
  activities: [],
  remainders: [],
  labels:[],
  careplanStatuses: [],
}

const lookupsSlice = createSlice({
    name: 'lookups',
    initialState,
    reducers: {
        updateSlots: (state, action) => {
            state.slots = action.payload
        },
        fetchActivities: (state, action) => {
            state.activities = action.payload   
        },
        fetchRemainders: (state, action) => {
            state.remainders = action.payload
        },
        fetchLabels: (state, action) => {
            state.labels = action.payload
        },
        updateCareplanStatuses: (state, action) => {
            state.careplanStatuses = action.payload
        }
    }
})

export const {updateSlots,fetchActivities,fetchRemainders,fetchLabels, updateCareplanStatuses} = lookupsSlice.actions

export default lookupsSlice.reducer;